<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.83333 6.33333V9.66667H13.8333V6.33333H8.83333ZM7.16667 6.33333H2.16667V9.66667H7.16667V6.33333ZM8.83333 13.8333H13.8333V11.3333H8.83333V13.8333ZM7.16667 13.8333V11.3333H2.16667V13.8333H7.16667ZM8.83333 2.16667V4.66667H13.8333V2.16667H8.83333ZM7.16667 2.16667H2.16667V4.66667H7.16667V2.16667ZM13.8333 0.5C14.7538 0.5 15.5 1.24619 15.5 2.16667V13.8333C15.5 14.7538 14.7538 15.5 13.8333 15.5H2.16667C1.24619 15.5 0.5 14.7538 0.5 13.8333V2.16667C0.5 1.24619 1.24619 0.5 2.16667 0.5H13.8333Z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "SpreadSheetIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
